import { Phone, Mail, Linkedin, Twitter, Github } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-gray-900 text-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="inline-flex items-center bg-white border-[3px] border-white rounded-xl p-3">
              <img
                src="/paragon-logo.png"
                alt="Paragon IT Services Pvt. Ltd."
                className="h-12 md:h-14 w-auto"
              />
            </div>
            <p className="mt-5 text-base md:text-lg font-medium text-white/70 max-w-md leading-relaxed">
              Paragon IT Services Pvt. Ltd. — a product-focused SaaS, AI and mobile
              engineering studio helping founders ship beautiful, scalable software.
            </p>
            <div className="mt-6 flex gap-3">
              <a data-testid="footer-social-linkedin" href="#" className="w-10 h-10 rounded-lg bg-white/10 border-2 border-white/30 hover:bg-[#FF477E] hover:border-[#FF477E] transition-all flex items-center justify-center" aria-label="LinkedIn">
                <Linkedin size={18} />
              </a>
              <a data-testid="footer-social-twitter" href="#" className="w-10 h-10 rounded-lg bg-white/10 border-2 border-white/30 hover:bg-[#FF477E] hover:border-[#FF477E] transition-all flex items-center justify-center" aria-label="Twitter">
                <Twitter size={18} />
              </a>
              <a data-testid="footer-social-github" href="#" className="w-10 h-10 rounded-lg bg-white/10 border-2 border-white/30 hover:bg-[#FF477E] hover:border-[#FF477E] transition-all flex items-center justify-center" aria-label="GitHub">
                <Github size={18} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-[#FBD46D] mb-4">Services</h4>
            <ul className="space-y-3 font-medium">
              <li><a href="#services" className="hover:text-[#FF477E] transition-colors">AI / ML Solutions</a></li>
              <li><a href="#services" className="hover:text-[#FF477E] transition-colors">Mobile App Development</a></li>
              <li><a href="#services" className="hover:text-[#FF477E] transition-colors">SaaS Development</a></li>
              <li><a href="#services" className="hover:text-[#FF477E] transition-colors">Web Development</a></li>
              <li><a href="#services" className="hover:text-[#FF477E] transition-colors">UI / UX Design</a></li>
              <li><a href="#services" className="hover:text-[#FF477E] transition-colors">Cloud & DevOps</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-[#FBD46D] mb-4">Reach us</h4>
            <ul className="space-y-4 font-medium">
              <li className="flex items-start gap-3">
                <Phone size={18} className="mt-1 text-[#FBD46D]" />
                <a data-testid="footer-phone" href="tel:+918130775107" className="hover:text-[#FF477E] transition-colors">+91 8130775107</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={18} className="mt-1 text-[#FBD46D]" />
                <a data-testid="footer-email" href="mailto:info@paragoninfotech.com" className="hover:text-[#FF477E] transition-colors break-all">info@paragoninfotech.com</a>
              </li>
            </ul>
            <div className="mt-6 bg-[#FF477E] border-2 border-white/20 rounded-xl p-4">
              <div className="text-xs font-bold uppercase tracking-widest mb-1">Ready to build?</div>
              <a href="#contact" className="font-display text-xl hover:underline">Start a project →</a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/15 flex flex-col md:flex-row justify-between gap-4 text-sm font-medium text-white/60">
          <div>© {new Date().getFullYear()} Paragon IT Services Pvt. Ltd. All rights reserved.</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
